export class ImageSize {
  width: number;
  height: number;
}

export const PANORAMA_SIZE = {width: 1920, height: 1080};
export const VIDEO_SIZE = {width: 1280, height: 720};

export const getImageSize = ({width, height}): ImageSize => {
  const viewportWidth = window.innerWidth - (window.innerWidth < 700 ? 0 : 40);
  const viewportHeight = window.innerHeight - 120;
  let resultWidth = width;
  let resultHeight = height;

  if (width > viewportWidth) {
    resultWidth = viewportWidth;
    resultHeight = Math.ceil(viewportWidth * (height / width));
  }

  if (resultHeight > viewportHeight) {
    resultHeight = viewportHeight;
    resultWidth = Math.ceil(viewportHeight * (width / height));
  }


  const size: ImageSize = {
    width: resultWidth,
    height: resultHeight
  };

  return size;
}

